import { useState, useEffect } from 'react';

const WHATSAPP_NUMBER = '34643939427';
const WHATSAPP_MESSAGE = 'Hi! I\'m interested in the Swasthya Ayurvedic Retreat and would love to learn more.';

const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [pulsing, setPulsing] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1200);
    const pulseTimer = setTimeout(() => setPulsing(false), 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(pulseTimer);
    };
  }, []);

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-[150] flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        <div className="bg-stone-900/95 backdrop-blur-sm text-stone-100 text-sm px-4 py-2.5 rounded-2xl rounded-br-sm whitespace-nowrap shadow-lg">
          <p className="font-medium">Chat with us on WhatsApp</p>
          <p className="text-stone-400 text-xs mt-0.5">Usually replies within minutes</p>
        </div>
      </div>

      {/* Button */}
      <div className="relative">
        {/* Pulse ring */}
        {pulsing && (
          <span
            className="absolute inset-0 rounded-full animate-ping opacity-40"
            style={{ backgroundColor: '#25D366' }}
          />
        )}

        <button
          onClick={handleClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          aria-label="Chat on WhatsApp"
          className="relative w-14 h-14 rounded-full flex items-center justify-center shadow-lg cursor-pointer transition-transform duration-200 hover:scale-110 active:scale-95"
          style={{ backgroundColor: '#25D366' }}
        >
          {/* WhatsApp icon using ri */}
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </button>
      </div>
    </div>
  );
};

export default WhatsAppButton;
